import axios from "axios";

const API = axios.create({
  baseURL: "https://api.shopsphere.co.in",
});


// ======================================================
// PUBLIC ROUTES
// These pages can be accessed without authentication.
// ======================================================

const PUBLIC_ROUTES = [
  "/",
  "/login",
  "/register",
  "/search",
  "/ai",
];


// ======================================================
// CHECK IF CURRENT PAGE IS PUBLIC
// ======================================================

const isPublicPage = () => {

  const path = window.location.pathname;


  // Home
  if (path === "/") {
    return true;
  }


  // Exact public routes
  if (PUBLIC_ROUTES.includes(path)) {
    return true;
  }


  // Product details
  if (path.startsWith("/product/")) {
    return true;
  }


  // Category pages
  if (path.startsWith("/category/")) {
    return true;
  }


  return false;
};


// ======================================================
// REQUEST INTERCEPTOR
// ======================================================

API.interceptors.request.use(
  (config) => {

    const adminToken =
      localStorage.getItem("adminToken");

    const userToken =
      localStorage.getItem("userToken");


    // --------------------------------------------------
    // AUTH ENDPOINTS
    // --------------------------------------------------

    if (
      config.url?.includes("/api/auth/login") ||
      config.url?.includes("/api/auth/register")
    ) {

      return config;

    }


    // --------------------------------------------------
    // ADMIN APIs
    // --------------------------------------------------

    if (config.url?.startsWith("/api/admin/")) {

      if (adminToken) {

        config.headers.Authorization =
          `Bearer ${adminToken}`;

      }

    }


    // --------------------------------------------------
    // USER APIs
    // --------------------------------------------------

    else {

      if (userToken) {

        config.headers.Authorization =
          `Bearer ${userToken}`;

      }

    }


    return config;

  },

  (error) => {

    return Promise.reject(error);

  }
);


// ======================================================
// RESPONSE INTERCEPTOR
// ======================================================

API.interceptors.response.use(

  (response) => {

    return response;

  },


  (error) => {

    const status =
      error.response?.status;


    // ==================================================
    // NO RESPONSE
    // Network/CORS/server error
    // ==================================================

    if (!error.response) {

      return Promise.reject(error);

    }


    // ==================================================
    // ADMIN AUTHENTICATION
    // ==================================================

    if (
      (status === 401 || status === 403) &&
      window.location.pathname.startsWith("/admin")
    ) {

      localStorage.removeItem("adminToken");

      window.location.href =
        "/admin/login";

      return Promise.reject(error);

    }


    // ==================================================
    // USER AUTHENTICATION
    // ==================================================

    if (
      (status === 401 || status === 403) &&
      !window.location.pathname.startsWith("/admin")
    ) {

      /*
       * IMPORTANT:
       *
       * DO NOT redirect every 401/403 to /login.
       *
       * Guests are allowed to visit public pages.
       *
       * Public pages can make optional authenticated
       * requests such as:
       *
       *   /api/wishlist
       *   /api/cart
       *   /api/reviews
       *
       * These APIs may correctly return 401 for guests.
       *
       * Therefore we only redirect if the CURRENT PAGE
       * itself is protected.
       */

      if (!isPublicPage()) {

        localStorage.removeItem("userToken");

        window.location.href =
          "/login";

      }

    }


    return Promise.reject(error);

  }
);


export default API;